<template>
  <div class="instructor_container">
    <CardTitle :title="data.title" class="card_title" :skipPage="skipList()" />

    <div class="list">
      <template v-if="type === 1">
        <div class="list_item" v-for="(item, index) in instructorData" :key="index" @click="skipHandle(item)">
          <div class="avator">
            <img :src="item.avatarFileUrl" class="avator-img" />
          </div>
          <div class="wrapper">
            <!-- <span class="label" v-if="item.type === 1">{{ $t('external_instructor') }}</span> -->
            <div class="insturctor">
              <p class="name">{{ item.name }}</p>
              <p class="level" v-if="item.lectureGradeName">{{ item.lectureGradeName }}</p>
            </div>
            <span class="corporation">{{ item.companyName }}</span>
            <div class="tag_group">
              <span class="tag_item active" v-if="item.teachingExperience"
                >{{ item.teachingExperience }}{{ $t('teaching_experience') }}</span
              >
            </div>
          </div>
        </div>
      </template>

      <template v-if="type === 3">
        <div class="list_item1" v-for="(item, index) in instructorData" :key="index" @click="skipHandle(item)">
          <div class="info">
            <div class="info_left">
              <div class="insturctor">
                <span class="name">{{ item.name }}</span>
                <span class="level" v-if="item.lectureGradeName">{{ item.lectureGradeName }}</span>
                <!-- <span v-if="item.type === 1" class="level level1">{{ $t('external') }}</span> -->
              </div>
              <span class="corporation">{{ item.companyName }}</span>
              <div class="tag_group">
                <span class="tag_item active" v-if="item.teachingExperience"
                  >{{ item.teachingExperience }}{{ $t('teaching_experience') }}</span
                >
                <template v-if="item.tagNames">
                  <span v-for="(item1, index1) in item.tagNames" :key="index1" class="tag_item active1">{{
                    item1
                  }}</span>
                </template>
              </div>
            </div>
            <img :src="item.avatarFileUrl" class="avator" />
          </div>
          <div class="data">
            <div class="data_item">
              <p class="data_value">{{ item.teachCourseNum }}</p>
              <p class="data_label">{{ $t('teach_course_num') }}</p>
            </div>
            <div class="data_item">
              <p class="data_value">{{ item.teachTotalDuration }}</p>
              <p class="data_label">{{ $t('teach_total_duration') }}</p>
            </div>
          </div>
        </div>
      </template>

      <template v-if="type === 2">
        <div class="swiper_wrapper">
          <div v-for="(item, index) in instructorData" :key="index" @click="skipHandle(item)">
            <div class="list_item1 swiper_item">
              <div class="info">
                <div class="info_left">
                  <div class="insturctor">
                    <span class="name">{{ item.name }}</span>
                    <span class="level" v-if="item.lectureGradeName">{{ item.lectureGradeName }}</span>
                    <!-- <span v-if="item.type === 1" class="level level1">{{ $t('external') }}</span> -->
                  </div>
                  <span class="corporation">{{ item.companyName }}</span>
                  <div class="tag_group">
                    <span class="tag_item active" v-if="item.teachingExperience"
                      >{{ item.teachingExperience }}{{ $t('teaching_experience') }}</span
                    >
                    <template v-if="item.tagNames">
                      <span v-for="(item1, index1) in item.tagNames" :key="index1" class="tag_item active1">{{
                        item1
                      }}</span>
                    </template>
                  </div>
                </div>
                <img :src="item.avatarFileUrl" class="avator" />
              </div>
              <div class="data">
                <div class="data_item">
                  <p class="data_value">{{ item.teachCourseNum }}</p>
                  <p class="data_label">{{ $t('teach_course_num') }}</p>
                </div>
                <div class="data_item">
                  <p class="data_value">{{ item.teachTotalDuration }}</p>
                  <p class="data_label">{{ $t('teach_total_duration') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import CardTitle from './CardTitle.vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useUsersStore } from '@/stores/users'
import { TabData } from '@/api/Models/AppTabs'

const props = defineProps<{
  data: LmsDecorateModule
}>()

const instructorData = computed(() => {
  try {
    console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})
const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).layoutType
  } catch (error) {
    return {}
  }
})

const router = useRouter()
const skipHandle = (item: { id: string }) => {
  router.push({ path: '/lecturerDetail', query: { lecturerId: item.id } })
}

const usersStore = useUsersStore()
const { tabOptions } = storeToRefs(usersStore)
const hasLecturerNavgation = computed(() => {
  return tabOptions.value.find((item: TabData) => {
    return item.defaultCode === 'lecturer'
  })
})

const skipList = () => {
  return hasLecturerNavgation.value ? '/lecturerCenterTab' : '/lecturerCenter'
}

// const themeColor = useThemeColor()
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');
@itemWidth: calc((100vw - 32px - 32px - 9px) / 2);
@itemWidth2: calc((100vw - 32px - 32px - 9px) / 2 - 24px);
@itemWidth3: calc((100vw - 32px - 24px - 24px - 9px) - 64px);
@itemWidth4: calc((289px - 32px - 24px - 9px) - 64px);

.instructor_container {
  margin: 12px 16px;
  padding: 0 12px 16px;
  border-radius: 8px;
  background-color: @contentBackground;
  .list {
    display: flex;
    flex-wrap: wrap;
    .list_item {
      width: @itemWidth;
      margin-top: 23px;
      padding: 12px;
      padding-top: 0;
      padding-bottom: 10px;
      flex: 0 0 auto;
      background-color: #f7f7f7;
      position: relative;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      .wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      &:nth-child(even) {
        margin-left: 9px;
      }
      .avator {
        margin: auto;
        margin-top: -10px;
        border-radius: 70px;
        background-color: #f7f7f7;
        border: solid 1px #ffffff;
        &-img{
          width: 70px;
          height: 70px;
          border-radius: 70px;
          object-fit: cover;
        }
      }
      .label {
        height: 19px;
        padding: 0 5px;
        position: absolute;
        top: 0;
        right: 0;
        background-color: #f39b00;
        color: #ffffff;
        font-size: 12px;
        transform: scale(0.833);
        border-bottom-left-radius: 5px;
        border-top-right-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .insturctor {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .name {
          margin-top: 12px;
          .text_multiple_etc(2);
          color: @textPrimary;
          font-size: 16px;
          font-weight: bold;
          word-break: break-all;
        }
        .level {
          margin-top: 5px;
          padding: 2px 4px;
          background-color: #a48b6e;
          border-radius: 3px;
          color: #fff;
          font-size: 12px;
          .text_etc;
          width: fit-content;
          max-width: @itemWidth2;
        }
      }
      .corporation {
        max-width: @itemWidth2;
        display: block;
        margin-top: 5px;
        color: @textNormal;
        font-size: 12px;
        opacity: 0.7;
        .text_etc;
      }
      .tag_group {
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        .tag_item {
          margin-bottom: 5px;
          padding: 3px 5px;
          background-color: #ebebeb;
          max-width: @itemWidth2;
          font-size: 12px;
          border-radius: 3px;
          .text_etc;
          &.active {
            background-color: inherit;
            color: #583611;
            opacity: 0.7;
            border: 1px solid #a48b6e;
          }
        }
      }
    }
    .list_item1 {
      width: 100%;
      height: 185px;
      // padding-bottom: 4px;
      margin-top: 10px;
      border-radius: 8px;
      background: linear-gradient(270deg, #f1d8bd, #f0e1cf);
      display: flex;
      flex-direction: column;
      .info {
        flex: 1;
        padding: 12px 12px 0;
        display: flex;
        // align-items: center;
        background-image: url(../../assets/images/instructor_light.png);
        background-position: right 0 top 0;
        background-size: 201px 105px;
        background-repeat: no-repeat;
        .info_left {
          width: 0;
          flex: 1;
          .insturctor {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .name {
              margin-right: 3px;
              max-width: @itemWidth3;
              color: #583611;
              font-size: 17px;
              font-weight: bold;
              .text_etc;
            }
            .level {
              margin-top: 5px;
              max-width: @itemWidth3;
              box-sizing: border-box;
              .text_etc;
              padding: 2px 4px;
              background-color: #a48b6e;
              border-radius: 3px;
              color: #fff;
              font-size: 12px;
              height: 17px;
              line-height: 15px;
            }
            .level1 {
              color: #583611;
              background-color: inherit;
              border: 1px solid #a48b6e;
              box-sizing: border-box;
            }
          }
          .corporation {
            width: 100%;
            display: block;
            margin-top: 4px;
            color: #583611;
            font-size: 13px;
            opacity: 0.7;
            .text_etc;
          }
          .tag_group {
            height: 22px;
            margin-top: 10px;
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            width: @itemWidth3;
            .tag_item {
              height: 22px;
              margin-bottom: 5px;
              margin-right: 5px;
              padding: 3px 5px;
              background-color: #ebebeb;
              font-size: 12px;
              border-radius: 3px;
              max-width: @itemWidth3;
              line-height: 15px;
              transform: scale(0.916);
              transform-origin: 0 0;
              .text_etc;
              &.active {
                background-color: inherit;
                color: #583611;
                border: 1px solid #a48b6e;
                opacity: 0.7;
              }
              &.active1 {
                background-color: rgb(225, 204, 181);
                color: #583611;
                opacity: 0.7;
              }
            }
          }
        }
        .avator {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          object-fit: cover;
          border: 1px solid #fff;
        }
      }
      .data {
        padding: 10px;
        margin: 4px;
        margin-top: 10px;
        background-color: #fff;
        border-radius: 4px;
        display: flex;
        .data_item {
          flex: 1;
          .flex_center;
          flex-direction: column;
          & + .data_item {
            border-left: 1px solid #f0f0f0;
          }
          .data_value {
            color: @textPrimary;
            font-size: 21px;
          }
          .data_label {
            color: @textSecondary99;
            font-size: 12px;
          }
        }
      }
    }
  }

  .swiper_wrapper {
    padding-bottom: 13px;
    width: 100%;
    overflow-x: auto;
    display: flex;
    .swiper_item {
      width: 289px;
      flex: 0 0 auto;
      margin-right: 10px;
      .insturctor {
        .name {
          max-width: @itemWidth4 !important;
        }
        .level {
          max-width: @itemWidth4 !important;
        }
      }
      .tag_group {
        width: @itemWidth4 !important;
      }
    }
  }
}
</style>
